import { Component } from '@angular/core';
import { Field } from '@app/core/model/other/field-config';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  standalone: false,
  templateUrl: './field-cell-renderer.component.html',
  styleUrl: './field-cell-renderer.component.scss'
})
export class FieldCellRendererComponent implements ICellRendererAngularComp {

  public field: Field;
  public computed: boolean;
  public required: boolean;

  /**
   * Initialise the cell.
   * @param params Parameters containing the value to display.
   */
  public agInit(params: ICellRendererParams<any, Field>): void {
    this.field = params.value;
    this.computed = this.field.computed;
    this.required = this.field.isRoot || this.field.isRelatedEntity;
  }

  /**
   * Inform ag-grid to handle refresh logic.
   * @param _ Unused.
   * @return false
   */
  public refresh(_: ICellRendererParams): boolean {
    return false;
  }
}
